import React, { useContext, useEffect } from "react";
import { Row, Col, Button } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import { ThemeContext } from "../context/ThemeContext";
import axios from "axios";

const TopNavbar = ({ user }) => {
    const { theme, toggleTheme } = useContext(ThemeContext);
    const navigate = useNavigate();

    const baseURL = process.env.REACT_APP_BASE_URL;
    const token = localStorage.getItem("token");

    // Check authentication status on component mount
    useEffect(() => {
        const checkAuth = () => {
            const token = localStorage.getItem("token");
            const login_user = localStorage.getItem("login_user");
            
            if (!token || !login_user) {
                navigate("/login");
            }
        };

        checkAuth();
    }, [navigate]);

    const handleProtectedNavigation = (path) => {
        const token = localStorage.getItem("token");
        const login_user = localStorage.getItem("login_user");
        
        if (token && login_user) {
            navigate(path);
        } else {
            // Store intended path and redirect to login
            navigate("/login", { state: { from: path } });
        }
    };

    const handleLogout = async () => {
        try {
            // Optional: Only call if you want to notify the backend
            if (baseURL && token) {
                await axios.post(
                    `${baseURL}/logout`,
                    {},
                    { headers: { Authorization: `Bearer ${token}` } }
                );
            }
        } catch (error) {
            console.error("Logout error:", error);
        } finally {
            // Always clear storage and redirect
            localStorage.clear();
            navigate("/login");
        }
    };

    return (
        <nav className={`top-navbar ${theme}`}>
            <Row className={`p-2 align-items-center ${theme === "dark" ? "bg-dark text-white" : "bg-light text-dark"}`}>
                <Col md={3}>
                    <h4 className="fw-bold">GatewayMAX+</h4>
                </Col>

                <Col md={6} className="d-flex justify-content-center gap-3">
                    <Link to="/dashboard" className={`btn ${theme === "dark" ? "btn-outline-light" : "btn-outline-primary"}`}>
                        Till
                    </Link>
                    <a 
                        className={`btn ${theme === "dark" ? "btn-outline-light" : "btn-outline-primary"}`}
                        onClick={() => handleProtectedNavigation("/invoice")}
                    >
                        Invoice
                    </a>
                    <Link to="/sales" className={`btn ${theme === "dark" ? "btn-outline-light" : "btn-outline-primary"}`}>
                        Sales
                    </Link>
                    <a 
                        className={`btn ${theme === "dark" ? "btn-outline-light" : "btn-outline-primary"}`}
                        onClick={() => handleProtectedNavigation("/settings")}
                    >
                        Settings
                    </a>
                </Col>

                <Col md={3} className="text-end">
                    Welcome,{" "}
                    <span className="fw-bold">
                        {user ? user.user_name.charAt(0).toUpperCase() + user.user_name.slice(1).toLowerCase() : "Guest"}
                    </span>!

                    <Button 
                        variant="outline-secondary"
                        size="sm" 
                        className="ms-2"
                        onClick={() => {
                            if (window.confirm("Are you sure you want to logout?")) {
                                handleLogout();
                            }
                        }}
                    >
                        Logout
                    </Button>

                    <Button 
                        variant="outline-secondary" 
                        size="sm" 
                        className="ms-2" 
                        onClick={toggleTheme}
                    >
                        {theme === "light" ? "Dark Mode" : "Light Mode"}
                    </Button>
                </Col>
            </Row>
        </nav>
    );
};

export default TopNavbar;